'use strict';

module.exports = () => {
    return (url, width = 934, height = 529, crop = 'fill', quality = 'auto') => {
        if (!url) {
            return '';
        }

        // Build up the options
        const options = `c_${crop},g_auto,h_${height},q_${quality},w_${width},g_auto`;

        return url.replace(/upload\/(.*?)\//i, 'upload/' + options + '/').replace('http:', 'https:');
    };
};



// WEBPACK FOOTER //
// ./widgets/filters/image.js